import { keyBy, sortBy } from 'lodash-es';

import { dcaController, enumController } from '../core';
import { mnoNameOrder } from '@/constants';
import { SelectItem } from '@/types';

export const getDcaOptions = async (params?: Record<string, unknown>) => {
  const dcas = await dcaController.getAllDcas(params);
  return dcas.map((dca) => ({
    label: dca.displayName,
    value: dca.uid,
  }));
};

export const getApprovedMnoOptions = async (channelId = '10DLC') => {
  const [mnosResult, approvedMnosResult] = await Promise.allSettled([
    enumController.getMnos(),
    dcaController.getApprovedMnos(),
  ]);
  if (
    mnosResult.status === 'rejected' ||
    approvedMnosResult.status === 'rejected'
  ) {
    return [] as SelectItem[];
  }

  const mnoDisplayNameMap = keyBy(mnosResult.value, 'networkId');
  const options: SelectItem[] = approvedMnosResult.value
    .filter((approvedMno) => approvedMno.channelId === channelId)
    .map((approvedMno) => ({
      label: mnoDisplayNameMap[approvedMno.mnoId]?.displayName ?? '--',
      value: String(approvedMno.mnoId),
    }));
  return sortBy(options, (option) => mnoNameOrder.indexOf(option.label));
};
